
export default function Toggle({ checked, label, handlier, disabled }: { checked: boolean, label: string, disabled: boolean; handlier: () => void }) {
    return (
        <div className="form-check form-switch mx-3">
            <input disabled={disabled} className="form-check-input" type="checkbox" id={"flexSwitchCheckChecked" + label} checked={checked} onChange={handlier} />
            <label className="form-check-label" htmlFor={"flexSwitchCheckChecked" + label}>{label}</label>
        </div>
    )
}
